import { Component, computed, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Transaction } from '@mysten/sui/transactions';
import { WidgetBoxComponent } from '../../../widgets/box/box.component';
import { WidgetButtonComponent } from '../../../widgets/button/button.component';
import { WidgetDataComponent } from '../../../widgets/data/data.component';
import { WidgetTextareaComponent } from '../../../widgets/textarea/textarea.component';
import { AlphaHelper } from '../../../helpers/alpha.helper';
import { ModalHelper } from '../../../helpers/modal.helper';
import { ToastHelper } from '../../../helpers/toast.helper';
import { WalletHelper } from '../../../helpers/wallet.helper';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-chat-send',
  templateUrl: './send.component.html',
  imports: [
    CommonModule,
    WidgetBoxComponent,
    WidgetButtonComponent,
    WidgetDataComponent,
    WidgetTextareaComponent,
  ]
})
export class AppChatSendComponent {

  /**
   * Alpha helper
   */
  alpha_helper = inject(AlphaHelper);

  /**
   * Modal helper
   */
  modal_helper = inject(ModalHelper);

  /**
   * Wallet helper
   */
  wallet_helper = inject(WalletHelper);

  /**
   * Toast helper
   */
  toast_helper = inject(ToastHelper);

  /**
   * Active account
   */
  active_account = computed(() => this.wallet_helper.active_account());

  /**
   * Message to send
   */
  message_input = signal('');

  /**
   * Digest of previous transaction
   */
  result_digest = signal('');

  /**
   * Message of previous transaction
   */
  result_message = signal('');

  /**
   * Whether transaction completed
   */
  completed = signal(false);

  /**
   * Whether action is processing
   */
  processing = signal(false);

  /**
   * View transaction
   */
  view() {
    if (this.result_digest()) {
      let link = environment.explorer_url + '/tx/' + this.result_digest();
      window.open(link, "_blank");
    }
  }

  /**
   * Reset status
   */
  reset() {
    this.completed.set(false);
    this.processing.set(false);
  }

  /**
   * Close modal
   */
  close() {
    this.modal_helper.close();
  }

  /**
   * Send message
   */
  async send() {
    // Make sure wallet is connected
    if (!this.active_account()) {
      this.toast_helper.error('Please connect your wallet to send message');
      return;
    }

    // Determine message
    if (!this.message_input()) {
      this.toast_helper.error('Fill message to send');
      return;
    }

    let address = this.active_account()?.address;
    if (address) {
      let transaction = new Transaction();

      transaction.moveCall({
        package: environment.config.latest_package_id,
        module: 'forum',
        function: 'send',
        arguments: [
          transaction.pure.address(address),
          transaction.pure.string(this.message_input()),
          transaction.object(environment.config.alpha.id),
        ]
      });

      this.processing.set(true);

      let result = await this.wallet_helper.execute(address, transaction);
      if (result.success) {
        if (result.events.length > 0) {
          let event = result.events[0].parsedJson;
          this.result_digest.set(result.digest);
          this.result_message.set(event.message);
          this.completed.set(true);
        }
      } else {
        this.completed.set(false);
      }

      this.processing.set(false);
    }
  }
}
